import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Enables the bug fix for LISP next page prefetch functionality
 */
export const FE_ENABLE_LISP_NEXT_PAGE_PREFETCH_BUG_FIX_250527 = experiment({
  name: "FE_ENABLE_LISP_NEXT_PAGE_PREFETCH_BUG_FIX_250527",
  identifier: "RetailerTokenInSession",
  client: "RETAILER",
  notifyAfter: "2025-06-20",
  defaultValue: false,
  productArea: "SEARCH",
});
